import { a as u } from "./logger-_fg_Za9y.js";
function d(...r) {
  return c(...r);
}
function c(...r) {
  return r.reduce((e, n) => a(e, n));
}
function a(r, e) {
  return u(r) && u(e) ? Object.entries(e).reduce(
    (n, [t, o]) => (n[t] = a(n[t], o), n),
    { ...r }
  ) : u(r) ? r : e;
}
function l(...r) {
  if (!r.every((e) => e == null))
    return r.filter((e) => Array.isArray(e)).reduce((e, n) => e.concat(n), []);
}
const i = "nosto.search.";
function f(r) {
  const e = `${i}${r}`;
  window.performance?.mark(`${e}.start`);
}
function s(r) {
  const e = `${i}${r}`;
  window.performance?.mark(`${e}.end`), window.performance?.measure(e, `${e}.start`, `${e}.end`);
}
function $(r) {
  return f(r), () => s(r);
}
function w(r) {
  return Array.from(new Set(r));
}
export {
  $ as a,
  c as b,
  d,
  l as m,
  w as u
};
